import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { SimpleGrid, VStack } from 'ui/Layout';
import Link from 'ui/Link';
import SegmentedControl from 'ui/SegmentedControl';
import Skeleton from 'ui/Skeleton';
import { Text } from 'ui/Typography';

import { useApiContext } from '../../../contexts/apiContext';
import StripePriceCard from './StripePriceCard';

enum Billing {
  Annual = 'Annual billing',
  Monthly = 'Monthly billing',
}

const StripePrices: React.FC = () => {
  const { api } = useApiContext();
  const [billing, setBilling] = useState(Billing.Annual);

  const { data, isLoading } = useQuery({
    queryKey: ['active-products'],
    queryFn: async () => {
      const res = await api().subscriptions.activeProductsList();
      return res.data;
    },
  });

  return (
    <VStack alignItems="center" gap={1}>
      <SegmentedControl
        value={billing}
        onValueChange={(e) => setBilling(e.value as Billing)}
        items={[Billing.Annual, Billing.Monthly]}
      />
      {billing === Billing.Annual ? (
        <Text fontSize="xs">
          You're saving $20 per month by choosing an annual plan!
        </Text>
      ) : (
        <Text color="red.500" fontSize="xs">
          Choose annual pricing to save $20 per month.
        </Text>
      )}
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mt={4} w="100%">
        {isLoading ? (
          <>
            <Skeleton.Row h="390px" w="full" />
            <Skeleton.Row h="390px" w="full" />
          </>
        ) : (
          data?.map(({ product, annual_price, monthly_price, metadata }) => (
            <StripePriceCard
              key={product.id}
              isAnnual={billing === Billing.Annual}
              price={billing === Billing.Annual ? annual_price : monthly_price}
              metadata={metadata}
            />
          ))
        )}
      </SimpleGrid>
      <Link fontSize="sm" href="mailto:sales@sankeyart.com" mt={4}>
        Or contact us for a custom plan
      </Link>
    </VStack>
  );
};

export default StripePrices;
